export const countryInfoEn = {
  title: 'Country Information',
  loading: 'Loading country information…',
  done: 'Done',
  share: 'Share',
  refresh: 'Refresh Data',
  notAvailable: 'Not available',
  errorLoad: 'Could not load country information.',
  retry: 'Retry',

  home: 'Home',
  countryCode: 'Country code',

  knowBeforeTitle: 'Know Before You Go',
  knowBeforeSubtitle: 'Visa, entry, and electrical adapters',

  visaTitle: 'Entry & Visa Requirements',
  visaRequired: 'Visa Required',
  visaNotRequired: 'No Visa Required',
  visaStatus: 'Status',
  visaMaxStay: 'Maximum stay',
  visaTap: 'Tap to view requirements',
  visaMissing: 'Not available. Check with your local embassy or consulate.',
  entryRequirements: 'Entry requirements',

  electricalTitle: 'Electrical Adapters',
  plugTypes: 'Plug types',
  voltage: 'Voltage',
  frequency: 'Frequency',
  adapterWarning:
    'An adapter (and possibly a converter) is likely required for US/Canada plugs.',
  electricalMissing: 'Electrical information is not available for this country.',

  healthTitle: 'Health & Safety',
  vaccinesRequired: 'Vaccines required',
  vaccinesRecommended: 'Vaccines recommended',
  vaccinesRoutine: 'Routine vaccines',
  healthRisks: 'Health risks',
  malaria: 'Malaria',
  foodWater: 'Food & water safety',
  insect: 'Insect bite prevention',
  healthMissing: 'Health information is not available.',
  tapToExpand: 'Tap to view details',

  embassyTitle: 'Embassy / Consulate',
  embassyMainPhone: 'Main phone',
  embassyEmergency: 'After-hours / emergency',
  embassyAddress: 'Address',
  embassyWebsite: 'Website',
  embassyMissing: 'No embassy listing for your nationality in this country.',
  embassyNeedNationality: 'Set your nationality in preferences to see embassy contacts.',
  embassyActive: 'Active listing',

  currencyTitle: 'Currency & Exchange',
  currencyQuickRef: 'Quick reference',
  currencyLoading: 'Fetching exchange rate…',
  currencyUnable: 'Unable to fetch live rate. Showing cached or unavailable.',
  currencyMissing: 'Currency information is not available.',
  currencyRateLabel: 'Exchange rate',

  tippingTitle: 'Tipping',
  tippingRestaurants: 'Restaurants',
  tippingTours: 'Tours & guides',
  tippingMissing: 'Tipping guidance is not available for this country.',

  rideHailTitle: 'Ride-Hail',
  rideHailAvailable: 'Services available',
  rideHailMissing: 'No ride-hail services listed for this country.',

  portTitle: 'Cruise Port',
  portPhone: 'Port phone',
  portAfterHours: 'After hours',
  portAddress: 'Address',
  portWebsite: 'Website',
  portCoords: 'Coordinates',
  portDock: 'Dock / berth',
  portArrival: 'Arrival',
  portDeparture: 'Departure',
  portMissing: 'Port information is not available.',
} as const;
